"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJoFailure = void 0;
function isJoFailure(failedResult) {
    return failedResult !== undefined && failedResult.succeeded === false;
}
exports.isJoFailure = isJoFailure;
